import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const tasksSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {},
});
// eslint-disable-next-line
export const {} = tasksSlice.actions;
export default tasksSlice.reducer;
